import ep from "../../../EpConst";
import env from "../../../../tools/Environment";
import AuthServiceConfig from "../../AuthServiceConfig";
const custom_config = {
  oauth: {
    [env.MYGAMES]: {
      referral: {
        enabled: true,
        url_param: "ref",
        cookie_param: "ref",
      },
      project_reg: {
        is_auto_reg_enabled: true,
        is_auto_accept_terms: true,
        is_subscribe_disabled: false,
      },
      profile_fields: [
        "profile_renamed",
        "early_access",
        "last_promotion_promo_code_type",
        "preorder",
        "beta_testing",
        "last_hwid",
        "registration_url",
        "steam_country",
        "forced_currency",
        "terms_accepted"
      ],
      social_ep_list: [
        ep.EP_FB,
        ep.EP_TWITTER,
        ep.EP_STEAM,
        ep.EP_MAILRU,
        ep.EP_VK,
        ep.EP_OK,
        ep.EP_GOOGLE,
        ep.EP_TWITCH,
      ],
      gc: {
        separated_gc_downloading: true,
        separated_steam_downloading: true,
      },
    },
  },
};
export default new AuthServiceConfig(custom_config);
